/* eslint-disable check-file/filename-blocklist -- pre-existing .jsx; this change only swaps an icon import, converting to .tsx is a separate migration */
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  useOutsideClick,
  Flex,
  Box,
  useDisclosure,
  Badge,
  Icon,
  InputGroup,
  InputLeftElement,
  Input,
  Text,
} from '@chakra-ui/react';
import { debounce } from 'lodash-es';
import SearchIcon from '@/icons/Search';
import { Tag, TagLabel, TagLeftIcon } from '@chakra-ui/react';
import { useState, useRef, useEffect } from 'react';
import { Check, MarkerPin01 as Location } from '@kula-ai/icons-core';

export const LocationFilter = ({
  locations = [],
  filter = {},
  onSelect = () => {},
}) => {
  const [selected, setSelected] = useState(filter?.office);
  const [options, setOptions] = useState(locations);

  const { onClose, isOpen, onToggle } = useDisclosure();
  const ref = useRef(null);
  const inputRef = useRef(null);

  const onChange = debounce(() => {
    const updatedOptions = locations.filter((location) => {
      return location?.key
        ?.toLocaleLowerCase()
        ?.includes(inputRef?.current?.value);
    });
    setOptions(updatedOptions);
  }, 300);

  const onClick = (selectedLocation) => {
    setSelected(selectedLocation);
    onSelect(selectedLocation);
    onClose();
  };

  useOutsideClick({
    ref: ref,
    handler: () => onClose(),
  });

  useEffect(() => {
    setSelected(filter?.office);
  }, [filter]);

  return (
    <Box ref={ref}>
      <Popover placement="bottom-start" isOpen={isOpen}>
        <PopoverTrigger>
          <Tag
            height="40px"
            bg={isOpen ? '#F6F7F8' : '#FFF'}
            borderRadius="full"
            borderWidth="1px"
            borderColor="light.border"
            _hover={{ background: '#F6F7F8' }}
            cursor="pointer"
            px="16px"
            onClick={onToggle}
          >
            <TagLeftIcon
              as={Location}
              width="16px"
              height="16px"
              color="#FF4B2B"
            />
            <TagLabel fontSize="sm" fontWeight="semiBold">
              Location
              {selected && (
                <Badge
                  width="20px"
                  height="20px"
                  bg="#131415"
                  color="white"
                  textAlign="center"
                  pt="2px"
                  pl="4px"
                  ml="4px"
                  borderRadius="50%"
                >
                  1
                </Badge>
              )}
            </TagLabel>
          </Tag>
        </PopoverTrigger>

        <PopoverContent width="350px">
          <PopoverBody padding="lg">
            {locations?.length > 5 && (
              <Box>
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <SearchIcon />
                  </InputLeftElement>
                  <Input
                    placeholder="Search Location"
                    ref={inputRef}
                    onChange={onChange}
                  />
                </InputGroup>
              </Box>
            )}

            <Box minH="30px" maxH="200px" overflow="auto">
              {options?.map((location) => {
                const isSelectedLocation = location?.key === selected;
                return (
                  <Flex
                    key={location?.key}
                    alignItems="center"
                    px="8px"
                    borderRadius="8px"
                    _hover={{ bg: 'light.hover' }}
                  >
                    <Box
                      flex="1"
                      py="12px"
                      px="sm"
                      fontSize="14px"
                      fontWeight={isSelectedLocation ? 600 : 400}
                      color={isSelectedLocation ? '#0043CE' : '#121314'}
                      _hover={{ bg: 'light.hover', borderRadius: '5px' }}
                      cursor="pointer"
                      borderRadius="sm"
                      onClick={() => onClick(location)}
                      textTransform="capitalize"
                    >
                      {location.key}
                    </Box>
                    {isSelectedLocation && <Icon as={Check} color="#0043CE" />}
                  </Flex>
                );
              })}
              {options.length === 0 && (
                <Box textAlign="center">
                  <Text variant="muted">No Option found</Text>
                </Box>
              )}
            </Box>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
};
